<header>
    <div class="header-inner-wrapper">
        <avenir-top-header [rightMenuItems]="topRightMenuItems" [phoneNumber]="phoneNumber" [currentCustomerId]="customerId"></avenir-top-header>
        <avenir-main-header [customerId]="customerId" [loggedInMenuItems]="loggedInMenuItems" [isLoggedIn]="isLoggedIn"
            (showSideNav)="showSideNav($event)"></avenir-main-header>
            
        <avenir-mobile-side-nav [customerId]="customerId" [loggedInMenuItems]="loggedInMenuItems" [bottomMenuItems]="topRightMenuItems"
            [phoneNumber]="phoneNumber" [isLoggedIn]="isLoggedIn" [showSideNav]="showSideNavStatus"
            (hideSideNav)="hideSideNav($event)">
        </avenir-mobile-side-nav>
    </div>
</header>